export default __webpack_public_path__ + "static/media/404.718d0e27.gif";